import AppHeader from '../../layout/AppHeader';
import RequestInfo from '../../xpost/request.info/RequestInfo.vue';
import RequestInfoAdd from '../../xpost/request.info/RequestInfoAdd.vue';

const RequestInfoRoutes = [
  {
    path: "/servicos/fale",
    name: "request.info",
    components: {
      header: AppHeader,
      default: RequestInfo,
    }
  },
  {
    path: "/servicos/fale/novo",
    name: "request.info.add",
    components: {
      header: AppHeader,
      default: RequestInfoAdd,
    }
  },
  {
    path: "/servicos/fale/novo/:tag",
    name: "request.info.add.new",
    components: {
      header: AppHeader,
      default: RequestInfoAdd,
    }
  },
]

export default RequestInfoRoutes;
